import React, {
  useCallback,
  useMemo,
  useState,
  useContext,
  useEffect
} from 'react'

import Modal from '../../../../components/Modal'
import ToggleSwitch from '../../../../components/ToggleSwitch'

import TermoCorinne2022 from '../../../../termosAceite/termoCorinne2022'

import Base from './Base'

import { FirebaseContext } from '../../../../Contexts'

const termoCorinneBailey2022 = 'termoCorinneBailey2022'

const CorinneBailey2022 = () => {
  const { firebaseFirestore: db } = useContext(FirebaseContext)

  const [mostrarTermoModal, setMostrarTermoModal] = useState(false)
  const [availableTicketsAmmount, setAvailableTicketsAmmount] = useState([])
  const [availableTicketsAmmountRef, setAvailableTicketsAmmountRef] = useState()

  const [formValues, setFormValues] = useState({
    termoAceito: false
  })

  const handleCheckedTermo = useCallback(() => {
    setFormValues((prev) => ({ ...prev, termoAceito: !prev.termoAceito }))
  }, [])

  const salvarOk = useMemo(() => {
    const {
      termoAceito
    } = formValues

    return !(
      termoAceito && availableTicketsAmmount > 0
    )
  }, [formValues, availableTicketsAmmount])

  useEffect(() => {
    const getAvailableTicketsAmmount = async () => {
      const docRef = await db
        .collection('sistema-reserva-tickets')
        .doc('corinne-bailey-rae-curitiba-2022')

      const data = await (await docRef.get()).data()

      setAvailableTicketsAmmountRef(docRef)
      setAvailableTicketsAmmount(data.quantidadeTicketsDisponiveis)
    }
    getAvailableTicketsAmmount()
  }, [])

  return (
    <Base
      description={() => (
        <div className="container">
          <div className="opcenquete align-left">
            <ToggleSwitch
              checked={formValues.termoAceito}
              setChecked={handleCheckedTermo}
              name="termoAceito"
            />
            <button
              type="button"
              className="btTransparente"
              onClick={() => {
                document.body.scrollTop = 0 // For Safari
                document.documentElement.scrollTop = 0 // FF, GC, Opera
                document.body.style.overflowY = 'hidden'
                setMostrarTermoModal(() => true)
              }}
            >
              <span className="texto-termo">
                Declaro que li e aceito os <strong>termos de privacidade</strong> do
                <strong> show da Corinne Bailey Rae</strong>.
              </span>
            </button>
          </div>
          <div className="texto-atencao" style={{ marginTop: '14px' }}>
            {!formValues.termoAceito && (
              <span>
                <strong>Atenção</strong>: Neste caso (
                <strong>NÃO ACEITE</strong>) não será possível sua participação
                no evento<strong> show da Corinne Bailey Rae</strong>.
                <br /><br />
                Por favor, em caso de dúvidas, envie uma mensagem para o aplicativo
                “Você na RPC”.
              </span>
            )}
          </div>

          {mostrarTermoModal && (
            <Modal
              setTermoAceito={handleCheckedTermo}
              setShowModal={setMostrarTermoModal}
            >
              <TermoCorinne2022 />
            </Modal>
          )}
        </div>
      )}
      title="Corinne"
      imagePath="/imgs/cupons/banner-corinne.png"
      programName="Corinne 2022"
      form={formValues}
      setForm={setFormValues}
      salvarOk={salvarOk}
      tipoTermo={termoCorinneBailey2022}
      availableTicketsAmmountRef={availableTicketsAmmountRef}
      db={db}
      availableTicketsAmmount={availableTicketsAmmount}
    />
  )
}

export default CorinneBailey2022
